import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import CustomButton from "../CustomButton";
import {Tooltip} from "@mui/material";
import {StoreContext} from "contexts/storeContext";

import {ReactComponent as EyeIcon} from "assets/img/eye.svg";

RetailerEshopLink.propTypes = {
    retailerSlug: PropTypes.string,
    eshopId: PropTypes.string,
    type: PropTypes.oneOf(["link", "button", "icon"])
};

function RetailerEshopLink({retailerSlug = null, eshopId = null, type = "link"}) {
    let disabled = false

    if (!eshopId || !retailerSlug) {
        disabled = true
    }

    const currentOrganizationUrl = useContext(StoreContext).getState()?.currentOrganization?.retrieved?.eshopUrl;

    if (currentOrganizationUrl === null) {
        return null;
    }

    if ("icon" === type) {
        return (
            <Tooltip title={<FormattedMessage id={disabled ? 'retailer.eshopLink.icon.label.disabled' : 'retailer.eshopLink.icon.label'} />}>
                <EyeIcon
                    onClick={() => disabled ? {} : window.open(currentOrganizationUrl+"/taxons/marchand/"+retailerSlug, '_blank')}
                    style={{
                        margin: '4px',
                        cursor: disabled ? 'not-allowed' : 'pointer',
                        color: disabled ? 'gray' : 'blue'
                    }}
                />
            </Tooltip>
        )
    }

    if ("button" === type) {
        return (
            <CustomButton
                disabled={disabled}
                onClick={() => window.open(currentOrganizationUrl+"/taxons/marchand/"+retailerSlug, '_blank')}
                style={{margin: "auto"}}
            >
                <FormattedMessage id={disabled ? 'retailer.eshopLink.button.label.disabled' : 'retailer.eshopLink.button.label'} />
            </CustomButton>
        )
    }

    return (
        <a href={"#"} onClick={(e) => {
            e.preventDefault();
            window.open(currentOrganizationUrl+"/taxons/marchand/"+retailerSlug, '_blank');
        }}>
            <FormattedMessage id={disabled ? 'retailer.eshopLink.link.label.disabled' : 'retailer.eshopLink.link.label'} />
        </a>
    );
}

export default RetailerEshopLink;
